import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ScheduleMessageDraftMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  id: Types.Scalars['ID'];
  scheduledAt: Types.Scalars['DateTime'];
}>;

export type ScheduleMessageDraftMutation = {
  __typename?: 'Mutation';
  scheduleMessageDraft: { __typename?: 'MessageDraft'; id: string; messageBatchId: string; status: Types.MessageDraftStatus; scheduledAt?: any | null; updatedAt: any };
};

export type CancelScheduledDraftMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  id: Types.Scalars['ID'];
}>;

export type CancelScheduledDraftMutation = {
  __typename?: 'Mutation';
  cancelScheduledDraft: { __typename?: 'MessageDraft'; id: string; messageBatchId: string; status: Types.MessageDraftStatus; updatedAt: any };
};

export type ScheduleMessageDraftBatchMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  messageBatchId: Types.Scalars['ID'];
  scheduledAt: Types.Scalars['DateTime'];
}>;

export type ScheduleMessageDraftBatchMutation = {
  __typename?: 'Mutation';
  scheduleMessageDraftBatch: Array<{
    __typename?: 'MessageDraft';
    id: string;
    messageBatchId: string;
    channel: Types.MessageDraftChannel;
    status: Types.MessageDraftStatus;
    scheduledAt?: any | null;
    updatedAt: any;
  }>;
};

export type CancelScheduledDraftBatchMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  messageBatchId: Types.Scalars['ID'];
}>;

export type CancelScheduledDraftBatchMutation = {
  __typename?: 'Mutation';
  cancelScheduledDraftBatch: Array<{
    __typename?: 'MessageDraft';
    id: string;
    messageBatchId: string;
    channel: Types.MessageDraftChannel;
    status: Types.MessageDraftStatus;
    updatedAt: any;
  }>;
};

export const ScheduleMessageDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ScheduleMessageDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledAt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduleMessageDraft' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'scheduledAt' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledAt' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ScheduleMessageDraftMutationFn = Apollo.MutationFunction<ScheduleMessageDraftMutation, ScheduleMessageDraftMutationVariables>;

/**
 * __useScheduleMessageDraftMutation__
 *
 * To run a mutation, you first call `useScheduleMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMessageDraftMutation, { data, loading, error }] = useScheduleMessageDraftMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      id: // value for 'id'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useScheduleMessageDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleMessageDraftMutation, ScheduleMessageDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<ScheduleMessageDraftMutation, ScheduleMessageDraftMutationVariables>(ScheduleMessageDraftDocument, baseOptions);
}
export type ScheduleMessageDraftMutationHookResult = ReturnType<typeof useScheduleMessageDraftMutation>;
export type ScheduleMessageDraftMutationResult = Apollo.MutationResult<ScheduleMessageDraftMutation>;
export type ScheduleMessageDraftMutationOptions = Apollo.BaseMutationOptions<ScheduleMessageDraftMutation, ScheduleMessageDraftMutationVariables>;
export const CancelScheduledDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelScheduledDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelScheduledDraft' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelScheduledDraftMutationFn = Apollo.MutationFunction<CancelScheduledDraftMutation, CancelScheduledDraftMutationVariables>;

/**
 * __useCancelScheduledDraftMutation__
 *
 * To run a mutation, you first call `useCancelScheduledDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledDraftMutation, { data, loading, error }] = useCancelScheduledDraftMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelScheduledDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelScheduledDraftMutation, CancelScheduledDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<CancelScheduledDraftMutation, CancelScheduledDraftMutationVariables>(CancelScheduledDraftDocument, baseOptions);
}
export type CancelScheduledDraftMutationHookResult = ReturnType<typeof useCancelScheduledDraftMutation>;
export type CancelScheduledDraftMutationResult = Apollo.MutationResult<CancelScheduledDraftMutation>;
export type CancelScheduledDraftMutationOptions = Apollo.BaseMutationOptions<CancelScheduledDraftMutation, CancelScheduledDraftMutationVariables>;
export const ScheduleMessageDraftBatchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ScheduleMessageDraftBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledAt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduleMessageDraftBatch' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'messageBatchId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'scheduledAt' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledAt' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ScheduleMessageDraftBatchMutationFn = Apollo.MutationFunction<ScheduleMessageDraftBatchMutation, ScheduleMessageDraftBatchMutationVariables>;

/**
 * __useScheduleMessageDraftBatchMutation__
 *
 * To run a mutation, you first call `useScheduleMessageDraftBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMessageDraftBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMessageDraftBatchMutation, { data, loading, error }] = useScheduleMessageDraftBatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageBatchId: // value for 'messageBatchId'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useScheduleMessageDraftBatchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleMessageDraftBatchMutation, ScheduleMessageDraftBatchMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ScheduleMessageDraftBatchMutation, ScheduleMessageDraftBatchMutationVariables>(ScheduleMessageDraftBatchDocument, baseOptions);
}
export type ScheduleMessageDraftBatchMutationHookResult = ReturnType<typeof useScheduleMessageDraftBatchMutation>;
export type ScheduleMessageDraftBatchMutationResult = Apollo.MutationResult<ScheduleMessageDraftBatchMutation>;
export type ScheduleMessageDraftBatchMutationOptions = Apollo.BaseMutationOptions<ScheduleMessageDraftBatchMutation, ScheduleMessageDraftBatchMutationVariables>;
export const CancelScheduledDraftBatchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelScheduledDraftBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelScheduledDraftBatch' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'messageBatchId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelScheduledDraftBatchMutationFn = Apollo.MutationFunction<CancelScheduledDraftBatchMutation, CancelScheduledDraftBatchMutationVariables>;

/**
 * __useCancelScheduledDraftBatchMutation__
 *
 * To run a mutation, you first call `useCancelScheduledDraftBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledDraftBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledDraftBatchMutation, { data, loading, error }] = useCancelScheduledDraftBatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageBatchId: // value for 'messageBatchId'
 *   },
 * });
 */
export function useCancelScheduledDraftBatchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CancelScheduledDraftBatchMutation, CancelScheduledDraftBatchMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CancelScheduledDraftBatchMutation, CancelScheduledDraftBatchMutationVariables>(CancelScheduledDraftBatchDocument, baseOptions);
}
export type CancelScheduledDraftBatchMutationHookResult = ReturnType<typeof useCancelScheduledDraftBatchMutation>;
export type CancelScheduledDraftBatchMutationResult = Apollo.MutationResult<CancelScheduledDraftBatchMutation>;
export type CancelScheduledDraftBatchMutationOptions = Apollo.BaseMutationOptions<CancelScheduledDraftBatchMutation, CancelScheduledDraftBatchMutationVariables>;
